import { Box, Colors } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from 'theme/selectors';

export const Container = styled(Box)<{
    $mb?: number;
    $borderColor?: string;
    $borderRadius?: number;
    $backgroundColor?: Colors;
}>`
    ${({ $mb }) => Number.isInteger($mb) && `margin-bottom: ${$mb}px;`};
    ${({ theme, $borderColor }) => $borderColor && `border: 1px solid  ${theme[$borderColor]};`};
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    width: 100%;
    > * {
        background-color: ${({ $backgroundColor }) =>
            $backgroundColor ? color($backgroundColor) : 'transparent'} !important;
    }
`;
